import { z } from 'zod'

/**
 * Shared Zod schemas.
 * Feature-specific schemas live in their feature folders.
 * Common re-usable schemas live here.
 */

// ── Primitives ──────────────────────────────────────────────────────────────

export const emailSchema = z
  .string()
  .min(1, 'Email is required')
  .email('Please enter a valid email address')

export const passwordSchema = z
  .string()
  .min(4, 'Password must be at least 4 characters')

export const phoneSchema = z
  .string()
  .regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number')
  .optional()
  .or(z.literal(''))

// ── Auth Schemas ────────────────────────────────────────────────────────────

export const loginSchema = z.object({
  email:      emailSchema,
  password:   z.string().min(1, 'Password is required'),
  rememberMe: z.boolean().optional().default(false),
})

export const registerSchema = z
  .object({
    name:            z.string().min(2, 'Name must be at least 2 characters'),
    email:           emailSchema,
    password:        passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: 'Passwords do not match',
    path:    ['confirmPassword'],
  })

export const forgotPasswordSchema = z.object({
  email: emailSchema,
})

export const resetPasswordSchema = z
  .object({
    password:        passwordSchema,
    confirmPassword: z.string(),
    token:           z.string().min(1),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: 'Passwords do not match',
    path:    ['confirmPassword'],
  })
